export default {
      id: "ic-hide-pass-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic-hide-pass-usage",
      toString: function () {
        return this.url;
      }
    }